/**
 * Known form events.
 */ var EFormEvent = /*#__PURE__*/ function(EFormEvent) {
    EFormEvent["TRANSLATION_FLAGS_CHANGED"] = "translation-flags-changed";
    return EFormEvent;
}(EFormEvent || {});
/**
 * General event bus for all events.
 */ class EventBus {
    events = {};
    /**
     * Subscribe to an event.
     * @param eventName - The name of the event.
     * @param callback - The callback to be executed when the event is published.
     * @returns An unsubscribe function.
     */ subscribe(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
        // Return an unsubscribe function
        return ()=>{
            this.events[eventName] = this.events[eventName].filter((cb)=>cb !== callback);
        };
    }
    /**
     * Publish an event.
     * @param eventName - The name of the event.
     * @param args - The arguments to be passed to the event callbacks.
     */ publish(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].forEach((callback)=>callback(...args));
        }
    }
}
/**
 * Event bus for form events.
 */ const FormEventBus = new EventBus();
Object.freeze(FormEventBus);
export { FormEventBus, EFormEvent };
